import {curry} from "ramda";

function hasChildren(node) {
    return (typeof node === "object")
        && (typeof node.children !== "undefined")
        && (node.children.length > 0);
}

export const TreeMapReduce = {
    reduce: curry(function reduce(reducerFn, init, node) {
        const acc = reducerFn(init, node);
        if (!hasChildren(node)) {
            return acc;
        }   
        return node.children.reduce(TreeMapReduce.reduce(reducerFn), acc);
    }),
    map: curry(function map(mapFn, node) {
        const newNode = mapFn(node);
        if (!hasChildren(node)) {
            return newNode;
        }
        newNode.children = node.children.map(TreeMapReduce.map(mapFn));
        return newNode;
    }),
};